import type { CoreSource } from '#shared/core'

/**
 * Returns true only when all licences block download.
 *
 * A paid licence still allows download, even with a trial/student/school licence.
 * Empty licence lists are left for callers to handle.
 */
export function hasOnlyBlockedLicenses(licenses: { ean: string }[] | null | undefined, eanNotDownloadable: readonly string[]): boolean {
  return !!licenses?.length && licenses.every(license => eanNotDownloadable.includes(license.ean))
}

export interface DownloadUser {
  source: CoreSource | 'UNKNOWN'
  licenses?: { ean: string }[] | null
}

/**
 * Feide logins never download, students and staff alike. Some universities hold commercial packages
 * for every seat, so the licences alone cannot keep a Feide login from downloading.
 */
export function isDownloadBlocked(user: DownloadUser, eanNotDownloadable: readonly string[]): boolean {
  return user.source === 'FEIDE' || hasOnlyBlockedLicenses(user.licenses, eanNotDownloadable)
}
